const $$splitNotFoundComponentImporter = () => import('/app/src/routes/{-$locale}.tsx?tsr-split=notFoundComponent');
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import React from 'react';
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { validateLocale } from '../i18n/language';
import type { Locale } from '../i18n/language';

// eslint-disable-next-line import-x/prefer-default-export
export const Route = createFileRoute('/{-$locale}')({
  beforeLoad: async ({
    params,
    location
  }) => {
    const {
      locale
    } = params;

    // Type-safe locale validation
    if (locale && !validateLocale(locale)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }

    // Redirect Dutch locale to non-locale paths
    if (locale === 'nl') {
      const {
        pathname
      } = location;
      // Remove /nl from the beginning of the path
      const redirectPath = pathname.replace(/^\/nl(?=\/|$)/, '') || '/';

      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: redirectPath,
        replace: true,
        statusCode: 301
      });
    }
    return {
      locale: locale as Locale || 'nl',
      isDefaultLocale: !locale || locale === 'nl'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  notFoundComponent: lazyRouteComponent($$splitNotFoundComponentImporter, 'notFoundComponent')
});